import { Label, slot } from "@fluentui/react-components";
import type {
  AppIconPreviewGalleryButtonProps,
  AppIconPreviewGalleryButtonState,
} from "./AppIconPreviewGalleryButton.types";
// eslint-disable-next-line no-restricted-imports
import { AppGalleryButton } from "@1js/acui-gallery/lib/Next";
import { Icon } from "@fluentui/react/lib/Icon";
import * as React from "react";
import {
  previewIconStyles,
  textStylesForIcon,
} from "./useAppIconPreviewGalleryButtonStyles.styles";
import type { IIconStyles } from "@fluentui/react/lib/Icon";
import { mergeCssFromPropsandCustomDefined } from "@1js/acui-common";

export const useAppIconPreviewGalleryButton = (
  props: AppIconPreviewGalleryButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppIconPreviewGalleryButtonState => {
  const iconStyles =
    props.previewIconProps && props.previewIconProps.styles
      ? mergeCssFromPropsandCustomDefined(
          props.previewIconProps.styles,
          previewIconStyles
        ).customDefinedCss
      : previewIconStyles;

  const buttonIcon = (
    <Icon {...props.previewIconProps} styles={iconStyles as IIconStyles} />
  );

  const labelStyle = mergeCssFromPropsandCustomDefined(
    props.style?.label,
    textStylesForIcon
  );

  const buttonLabel = slot.optional(props.label, {
    defaultProps: {
      children: props.label,
      style: labelStyle.customDefinedCss as React.CSSProperties,
    },
    elementType: Label,
  });

  const root = slot.always(
    { ...props, ref },
    {
      defaultProps: {
        ...props,
        automationType: "AppIconPreview",
        uniqueId: props.id,
        ariaLabel: props.ariaLabel ?? props.label,
        shouldTakeFocus: props.shouldTakeFocus,
        icon: buttonIcon,
        ref,
      },
      elementType: AppGalleryButton,
    }
  );

  const state: AppIconPreviewGalleryButtonState = {
    ...props,
    components: {
      root: AppGalleryButton,
      buttonLabel: Label,
    },
    root,
    buttonLabel,
  };
  return state;
};
